import React from "react";
import "./Team.css";
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const teamMembers = [
 {
    name: "Rehan Shaikh",
    role: "Chief Executive Officer (CEO)",
    desc: "A visionary leader with a strong focus on growth, innovation, and long-term strategy.",
    img: "https://res.cloudinary.com/di82vlbpn/image/upload/v1764951526/WhatsApp_Image_2025-12-05_at_9.14.41_PM_hvxnwf.jpg"
  },
  {
    name: "Islam Bhai",
    role: "Chief Operating Officer (COO)",
    desc: "Oversees daily operations, manages workflow, and ensures smooth execution of all projects.",
    img: "https://res.cloudinary.com/di82vlbpn/image/upload/v1765032278/islam_gjd7yu.jpg"
  },
  {
    name: "Haseeb Ansari",
    role: "Chief Technology Officer (CTO)",
    desc: "Turns complex ideas into fast, scalable code with a focus on performance.",
    img: "https://res.cloudinary.com/di82vlbpn/image/upload/v1765032272/hasin_i3eqwe.jpg"
  },
    {
    name: "Athar Jamal",
    role: "Project Manager (PM)",
    desc: "Coordinates project timelines, team responsibilities, and communication to deliver quality results.",
    img: "https://res.cloudinary.com/di82vlbpn/image/upload/v1765107927/WhatsApp_Image_2025-12-06_at_8.16.30_PM_y5hmaq.jpg"
  },
  {
    name: "Sabeena Khatoon",
    role: "Chief Financial Officer (CFO)",
    desc: "Connects products to people through storytelling, content, and data-driven campaigns.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1fYaY9LEjaK0yhT3WsncM36y6MD9sLCHU4A&s"
  },

  {
    name: "Anupama",
    role: "Director",
    desc: "Provides strategic decision-making and ensures long-term growth and standards.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1fYaY9LEjaK0yhT3WsncM36y6MD9sLCHU4A&s"
  },
 
];

const Team = () => {
  return (
    <div className="team-section">

     <Helmet>
  <title>Meet Our Expert Team | Star Aluminium Works</title>
  <meta name="description" content="Highly trained aluminium and glass professionals led by CEO Rehan Shaikh, delivering quality workmanship across Uttar Pradesh." />
</Helmet>
 
     
      <h2 className="team-title">Our Team</h2>
      <p className="team-subtitle">Meet the minds behind our success</p>

      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="team-img">
              <img src={member.img} alt={member.name} />
            </div>

            <div className="team-content">
              <h3>{member.name}</h3>
              <span className="team-role">{member.role}</span>
              <p>{member.desc}</p>

              <div className="team-social">
                <a href="#"><FaLinkedin /></a>
                <a href="#"><FaTwitter /></a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
